var module = angular.module('octopusApp.configuration');

module.directive('subscriptionEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/configuration/subscriptions/views/editor.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/subscriptions/directives/subscription_editor.js
// module id = 2670092245776515
// module chunks = 1